<script>
import SideMenuItem from '../side-menu-item';
import Config       from '../../../../libs/config';

export default {
  name  : 'side-menu-like-products',
  mixins: [SideMenuItem],
  data  : function() {
    const baseUrl = Config.SERVICE_LINK.ATCOSME.SP.URL;

    // 以下のリダイレクト処理について、詳しくは以下のURLをご参照ください。
    // https://github.com/istyle-inc/cosme_mobile/blob/6170a383862aeadc87c4d535bcb7964c34c2fc9b/spnweb/spweb-modules/smartphone/controllers/LoginPromoteController.php

    // ログイン時にはリダイレクトURLに飛ばす
    const urlForRedirect = new URL('/login-promote/like', baseUrl);
    // ログインしていないときはログイン誘導画面に飛ばす
    const urlForLoginPromote = new URL('/login-promote', baseUrl);
    urlForLoginPromote.searchParams.set('redirect_for', 'like');

    const link = this.$store.state.context.viewer.istyleId ? urlForRedirect.href: urlForLoginPromote.href;

    return {
      label    : 'Like商品',
      link     : link,
      analytics: { label: 'side_menu_like_products' },
    };
  },
};
</script>
